import { render, staticRenderFns } from "./InterviewModalTranscriptTab.vue?vue&type=template&id=5235eb0a&"
import script from "./InterviewModalTranscriptTab.vue?vue&type=script&lang=js&"
export * from "./InterviewModalTranscriptTab.vue?vue&type=script&lang=js&"
import style0 from "./InterviewModalTranscriptTab.vue?vue&type=style&index=0&id=5235eb0a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports